import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { id: "text" }, "Text", -1)
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoreInfo = _resolveComponent("MoreInfo")!
  const _component_CommentaryLine = _resolveComponent("CommentaryLine")!
  const _component_BackToTop = _resolveComponent("BackToTop")!
  const _component_ArticleContainer = _resolveComponent("ArticleContainer")!
  const _component_CommentarySection = _resolveComponent("CommentarySection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ArticleContainer, { class: "showLinks" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (_ctx.t('commentary.text_infotext'))
            ? (_openBlock(), _createBlock(_component_MoreInfo, {
                key: 0,
                showInfo: _ctx.showInfo,
                infoText: _ctx.t('commentary.text_infotext'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showInfo = !_ctx.showInfo)),
                class: "ml-4"
              }, null, 8, ["showInfo", "infoText"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.showInfo ? 'max-h-large' : 'max-h-0', "text-m overflow-hidden transition transition-maxHeight ease-in-out duration-700"])
        }, [
          _createElementVNode("div", {
            class: "bg-grey-verylight px-3 py-5 mt-7",
            innerHTML: _ctx.t('commentary.text_infotext')
          }, null, 8, _hoisted_3)
        ], 2),
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentary.text_structure, (line, index) => {
            return (_openBlock(), _createBlock(_component_CommentaryLine, {
              key: line,
              line: line,
              previous: index > 0 ? _ctx.commentary.text_structure[index - 1] : undefined
            }, null, 8, ["line", "previous"]))
          }), 128))
        ]),
        _createVNode(_component_BackToTop)
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentary.sections, (section) => {
      return (_openBlock(), _createElementBlock("div", {
        key: section.id,
        class: "showLinks"
      }, [
        (section.heading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("h2", {
                class: "text-center pt-6",
                id: section.id
              }, _toDisplayString(section.heading), 9, _hoisted_4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.sections, (subSection) => {
                return (_openBlock(), _createBlock(_component_CommentarySection, {
                  key: subSection.ud,
                  class: "showLinks my-3",
                  id: subSection.id,
                  section: subSection
                }, null, 8, ["id", "section"]))
              }), 128))
            ], 64))
          : (_openBlock(), _createBlock(_component_CommentarySection, {
              key: 1,
              class: "showLinks my-3",
              id: section.id,
              section: section
            }, null, 8, ["id", "section"]))
      ]))
    }), 128))
  ], 64))
}